import { render, staticRenderFns } from "./ProductBrowse.vue?vue&type=template&id=1bdf5268"
import script from "./ProductBrowse.vue?vue&type=script&lang=ts"
export * from "./ProductBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bdf5268')) {
      api.createRecord('1bdf5268', component.options)
    } else {
      api.reload('1bdf5268', component.options)
    }
    module.hot.accept("./ProductBrowse.vue?vue&type=template&id=1bdf5268", function () {
      api.rerender('1bdf5268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/ProductBrowse.vue"
export default component.exports